import React, { useState } from "react";

const ProgramModulesYEI = () => {
  const [openSectionIndex, setOpenSectionIndex] = useState(null);
  const toggleSectionDetails = (index) => {
    setOpenSectionIndex((prev) => (prev === index ? null : index));
  };
  const sections = [
    {
      title: "Introduction to Diplomacy (2.5 ECTS)",
      description: [
        "Explore the evolution, principles, and practices of diplomacy in global contexts.",
      ],
    },
    {
      title: "Introduction to International Relations (2.5 ECTS)",
      description: [
        "Explore key theories, concepts, and frameworks in international relations, focusing on global cooperation, conflict resolution, power dynamics, and governance in an interconnected world.",
      ],
    },
    {
      title: "Climate Diplomacy (2.5 ECTS)",
      description: [
        "Examine the intersection of climate change and global politics, equipping diplomats with strategies to negotiate sustainable agreements and address pressing environmental challenges worldwide.",
      ],
    },
    {
      title: "Foreign Service Essentials (2.5 ECTS)",
      description: [
        "Understand the principles, protocols, and practices of foreign service, focusing on effective representation, policy advocacy, and promoting national interests.",
      ],
    },
    {
      title: "Public Diplomacy and Strategic Communication (2.5 ECTS)",
      description: [
        "Master techniques for engaging global audiences, shaping public opinion, and employing communication strategies to enhance a nation’s image and foster international collaboration.",
      ],
    },
    {
      title: "International Law Foundations (2.5 ECTS)",
      description: [
        "Examine the core principles and frameworks of international law, focusing on treaties, human rights law, and the rule of law in global governance.",
      ],
    },
    {
      title: "Gender Issues and Empowerment in Diplomacy (2.5 ECTS)",
      description: [
        "Analyse the role of gender in international relations, with strategies for empowering women and promoting inclusivity in diplomacy.",
      ],
    },
    {
      title: "Civil Society and Diplomacy (2.5 ECTS)",
      description: [
        "Explore the growing influence of civil society organisations in shaping diplomatic priorities and their partnerships with governments and international institutions.",
      ],
    },
    {
      title: "Emerging Trends in International Relations (2.5 ECTS)",
      description: [
        "Analyse evolving global issues, including technology, cyber diplomacy, and new power dynamics, preparing for challenges in a rapidly transforming international landscape.",
      ],
    },
    {
      title: "Migration Management (2.5 ECTS)",
      description: [
        "Address the challenges of international migration, including policy responses, integration strategies, and transnational cooperation to manage migration effectively.",
      ],
    },
    {
      title:
        "Regional Diplomacy: Africa, Asia, and Europe (2.5 ECTS) (Moved from Diploma)",
      description: [
        "Examine regional cooperation frameworks, focusing on economic integration, cultural diplomacy, and policymaking.",
      ],
    },
    {
      title:
        "Conflict Resolution and Mediation (2.5 ECTS) (Moved from Diploma)",
      description: [
        "Develop advanced skills in analysing and mediating international disputes to achieve sustainable outcomes.",
      ],
    },
    {
      title: "Diplomatic Protocol and Practice (2.5 ECTS) (Moved from Diploma)",
      description: [
        "Master essential diplomatic protocols and etiquette for effective representation in multilateral environments.",
      ],
    },
  ];

  return (
    <div>
      <section
        id="program-modules-ep"
        className="p-3 scroll-m-14 md:scroll-mt-44 z-[4]"
      >
        <div className="max-w-6xl mx-auto">
          <div className="flex justify-center pb-5">
            <p className="border-b-4 border-sdorange inline-block text-center text-2xl font-bold">
              Programme Modules
            </p>
          </div>
          <div className="px-5">
            {sections.map((section, index) => (
              <div
                key={index}
                className="border-2 rounded-md bg-gray-400 bg-opacity-50 border-sdorange p-4 w-full mb-6 cursor-pointer hover:bg-gray-300"
                onClick={() => toggleSectionDetails(index)}
              >
                <div className="flex justify-between items-center">
                  <div className="flex items-center space-x-2">
                    <img
                      src="/image-fix/academic-programmes/certified-courses/icons/play-circle-svgrepo-com.svg"
                      alt="Play Icon"
                      className="h-6 w-6"
                    />
                    <h3 className="text-xl font-semibold">{section.title}</h3>
                  </div>
                  <div>
                    {openSectionIndex === index ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 text-gray-700"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5 15l7-7 7 7"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 text-gray-700"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    )}
                  </div>
                </div>
                {openSectionIndex === index && (
                  <div className="mt-3 p-2 bg-sdbodywhite rounded shadow">
                    <ul className="list-disc pl-5">
                      {section.description.map((desc, idx) => (
                        <li key={idx} className="text-sm text-gray-600 mb-2">
                          {desc}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProgramModulesYEI;
